import React from "react";
import {updateStore} from "./update.store";

const storesContext = React.createContext({
    updateStore,
});

export const useStores = () => React.useContext(storesContext);